/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_CompanyInputs */

const en_st_wl_company = /** @type {(inputs: St_Wl_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agency / company`)
};

const id_st_wl_company = /** @type {(inputs: St_Wl_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agensi / perusahaan`)
};

/**
* | output |
* | --- |
* | "Agency / company" |
*
* @param {St_Wl_CompanyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_company = /** @type {((inputs?: St_Wl_CompanyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_CompanyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_company(inputs)
	return en_st_wl_company(inputs)
});